import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    Bouton,
    InputMi,
    Checkbox,
    SegmentLoader,
    Row,
    Col,
    GroupeBouton,
} from '@design-system-etat/dsfr-react';
import { FormProvider, useForm } from 'react-hook-form';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import FileUploadeAbstract from 'components/Commun/Form/InputFiles/Model/FileUploadeAbstract';
import { getTelFormatWithoutSpace } from 'components/Commun/Form/maskFunctions';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_COMPTE_CREER_ADRESSE_PRINCIPALE_URL,
    API_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE_URL,
    API_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2_URL,
    API_POST_VERIFIER_BAN,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE,
    CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
    CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
    CONTEXT_POST_VERIFIER_BAN,
} from 'constants/apiUrls.constants';
import { REGEXP_EMAIL } from 'constants/contraintes.constants';
import { getMessageErreurChampManquant } from 'utils/utils';
import ModalBan from 'components/modalBan/ModalBan';
import FormulaireAdresseSimple from 'components/form/formulaireAdresse/FormulaireAdresseSimple';
import FormulaireJustificatifsDomicile from 'components/form/formulaireAdresse/FormulaireJustificatifsDomicile';
import FormulaireCertificatMedical from 'components/form/certificatMedical/FormulaireCertificatMedical';
import formaterCreationAdressePrincipal from './FormaterCreationAdressePrincipal';

const CreerCompteAdresse = ({
    uuidBrouillon,
    postApi,
    reinitialiseApi,
    setEtapeAdresse,
    isAncienLicencie,
    data,
    isLoading,
    retourEtape,
    isLoadingRenseignerAdressePrincipale,
    dataRenseignerAdressePrincipale,
    dataAdressePrincipaleRenseignee,
    motifs,
    isLoadingJustificatifsDomicile,
    dataRenseignerJustificatifsDomicile,
    erreurJustificatifsDomicile,
    isLoadingCertificatMedicalArs,
    dataRenseignerCertificatMedicalArs,
    erreurCertificatMedicalArs,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
        defaultValues: { ...dataAdressePrincipaleRenseignee },
    });
    const { handleSubmit, register, formState, watch, reset, setValue, unregister } = hookForm;
    const { isValid } = formState;
    const [adresseResponsable, setAdresseResponsable] = useState(null);
    const [ouvrirModalBan, setOuvrirModalBan] = useState(false);
    const [justificatifsDomicile, setJustificatifsDomicile] = useState(null);
    const [certificatMedicalArs, setCertificatMedicalArs] = useState(null);

    const numeroNonFrancais = (telephone) => {
        if (watch(telephone) && watch(telephone).length > 10) {
            return {
                message:
                    'Le format du numéro de téléphone ne correspond pas à un numéro de téléphone français',
            };
        }
        return null;
    };

    // on mount et unmount
    useEffect(() => {
        window.scrollTo(0, 0);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE);
        if (
            dataAdressePrincipaleRenseignee &&
            dataAdressePrincipaleRenseignee.justificatifsDomicile
        ) {
            setValue(
                'justificatifsDomicile',
                dataAdressePrincipaleRenseignee.justificatifsDomicile,
            );
        }

        if (dataAdressePrincipaleRenseignee && dataAdressePrincipaleRenseignee.certificatMedical) {
            setValue('certificatMedical', dataAdressePrincipaleRenseignee.certificatMedical);
        }

        return () => {
            reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
            reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE);
        };
    }, []);

    async function postJustificatifsDomicile() {
        reinitialiseApi(
            CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
        );
        justificatifsDomicile.forEach((value, index) => {
            postApi(
                usagerClientReducer,
                API_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2_URL.replace(
                    '{index}',
                    index + 1,
                ),
                {
                    justificatifDomicile: value,
                    key: index + 1,
                    uuidBrouillon,
                },
                CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
            );
        });
    }

    async function postCertificatMedicalArs() {
        reinitialiseApi(
            CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
        );
        postApi(
            usagerClientReducer,
            API_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE_URL,
            {
                certificatMedical: certificatMedicalArs,
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE,
        );
    }

    useEffect(() => {
        if (
            !isLoadingRenseignerAdressePrincipale &&
            dataRenseignerAdressePrincipale &&
            dataRenseignerAdressePrincipale.uuidBrouillon
        ) {
            setOuvrirModalBan(false);

            if (justificatifsDomicile) {
                postJustificatifsDomicile();
            }

            if (certificatMedicalArs) {
                postCertificatMedicalArs();
            }
        }
    }, [isLoadingRenseignerAdressePrincipale, dataRenseignerAdressePrincipale]);

    function conditionPourPasserEtapeSuivante() {
        const adresseEnvoyee =
            !isLoadingRenseignerAdressePrincipale &&
            dataRenseignerAdressePrincipale &&
            dataRenseignerAdressePrincipale.uuidBrouillon;

        const justificatifDomicileEnvoyee =
            isLoadingJustificatifsDomicile === false &&
            dataRenseignerJustificatifsDomicile &&
            !erreurJustificatifsDomicile;

        const certificatMedicalArsEnvoyee =
            isLoadingCertificatMedicalArs === false &&
            dataRenseignerCertificatMedicalArs &&
            !erreurCertificatMedicalArs;

        return adresseEnvoyee && (justificatifDomicileEnvoyee || certificatMedicalArsEnvoyee);
    }

    useEffect(() => {
        if (conditionPourPasserEtapeSuivante()) {
            setEtapeAdresse(adresseResponsable);
        }
    }, [
        isLoadingRenseignerAdressePrincipale,
        dataRenseignerAdressePrincipale,
        isLoadingJustificatifsDomicile,
        dataRenseignerJustificatifsDomicile,
        erreurJustificatifsDomicile,
        isLoadingCertificatMedicalArs,
        dataRenseignerCertificatMedicalArs,
        erreurCertificatMedicalArs,
    ]);

    const hasFormValid = () => {
        return (watch('typeEtNomDeVoie') || watch('lieuDit')) && isValid;
    };

    const fermerModal = () => {
        setOuvrirModalBan(false);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
    };

    function postAdresse(donnees) {
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE);
        postApi(
            usagerClientReducer,
            API_COMPTE_CREER_ADRESSE_PRINCIPALE_URL,
            donnees,
            CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE,
        );
    }

    const onSubmit = (dataForm) => {
        const adresseAverifier = {
            numeroVoie: dataForm.numeroDeVoie,
            libelleVoie: dataForm.typeEtNomDeVoie,
            codePostal: dataForm.codePostal,
            ville: dataForm.ville,
            extension: dataForm.extension,
            lieuDit: dataForm.lieuDit,
        };

        setAdresseResponsable(dataForm);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        postApi(
            usagerClientReducer,
            API_POST_VERIFIER_BAN,
            adresseAverifier,
            CONTEXT_POST_VERIFIER_BAN,
        );
        setOuvrirModalBan(true);
    };

    const conserver = async () => {
        setOuvrirModalBan(false);
        const dataFormat = await formaterCreationAdressePrincipal(
            adresseResponsable,
            uuidBrouillon,
            false,
        );
        setJustificatifsDomicile(dataFormat.justificatifsDomicile);
        dataFormat.justificatifsDomicile = null;
        setCertificatMedicalArs(dataFormat.certificatMedical);
        dataFormat.certificatMedical = null;
        postAdresse(dataFormat);
    };

    const remplacer = async () => {
        const dataFormat = await formaterCreationAdressePrincipal(
            adresseResponsable,
            uuidBrouillon,
            true,
        );
        dataFormat.numeroDeVoie = data.numeroVoie;
        dataFormat.typeEtNomDeVoie = data.libelleVoie;
        dataFormat.extension = data.extension;
        dataFormat.lieuDit = data.lieuDit;
        dataFormat.codePostal = data.codePostal;
        dataFormat.ville = data.ville;

        const champsARemplacer = {
            numeroDeVoie: data.numeroVoie,
            typeEtNomDeVoie: data.libelleVoie.toUpperCase(),
            extension: data.extension,
            lieuDit: data.lieuDit,
            codePostal: data.codePostal,
            ville: data.ville.toUpperCase(),
            email: dataFormat.email,
            numeroSia: dataFormat.numeroSia,
            telephonePrincipal: dataFormat.telephonePrincipal,
            telephoneSecondaire: dataFormat.telephoneSecondaire,
            immatriculationVehicule: dataFormat.immatriculationVehicule,
            typeJustificatifDomicile: dataFormat.typeJustificatifDomicile,
        };

        reset(champsARemplacer);

        setAdresseResponsable({
            ...adresseResponsable,
            ...champsARemplacer,
        });

        setOuvrirModalBan(false);
        setJustificatifsDomicile(dataFormat.justificatifsDomicile);
        dataFormat.justificatifsDomicile = null;
        setCertificatMedicalArs(dataFormat.certificatMedical);
        dataFormat.certificatMedical = null;
        await postAdresse(dataFormat);
    };

    return (
        <SegmentLoader
            isLoading={
                isLoading ||
                isLoadingRenseignerAdressePrincipale ||
                isLoadingJustificatifsDomicile ||
                isLoadingCertificatMedicalArs
            }
        >
            {ouvrirModalBan && (
                <ModalBan
                    residence="principale"
                    fermerModal={fermerModal}
                    data={data}
                    isLoading={
                        isLoading ||
                        isLoadingRenseignerAdressePrincipale ||
                        isLoadingJustificatifsDomicile ||
                        isLoadingCertificatMedicalArs
                    }
                    remplacer={remplacer}
                    conserver={conserver}
                />
            )}
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col col={12}>
                            <h5>Adresse postale en France</h5>
                        </Col>
                    </Row>
                    <FormulaireAdresseSimple />
                    <FormulaireJustificatifsDomicile />
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <Checkbox
                                type="checkbox"
                                name="itinerant"
                                label="Itinérant"
                                value="itinerant"
                                {...register('itinerant', {
                                    onChange: ({ target }) => {
                                        if (!target.checked) {
                                            unregister('immatriculationVehicule');
                                        }
                                    },
                                })}
                            />
                            {watch('itinerant') && (
                                <div>
                                    <InputMi
                                        uppercase
                                        label="Immatriculation de votre résidence mobile terrestre"
                                        texteAide="Caravane, camping-car,..."
                                        {...register('immatriculationVehicule', {
                                            required: getMessageErreurChampManquant(
                                                'Immatriculation du véhicule',
                                            ),
                                            setValueAs: (v) => v.toUpperCase(),
                                        })}
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>

                    <Row className="margin-top-lg">
                        <Col col={12}>
                            <h5>Informations</h5>
                        </Col>
                    </Row>
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <InputMi
                                label="E-mail"
                                type="text"
                                required
                                {...register('email', {
                                    required: getMessageErreurChampManquant('E-mail'),
                                    pattern: {
                                        value: REGEXP_EMAIL,
                                        message: "Le format de l'adresse mail n'est pas valide",
                                    },
                                })}
                                error={formState.errors ? formState.errors.email : null}
                            />
                        </Col>
                    </Row>
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Téléphone"
                                required
                                type="text"
                                maxLength="10"
                                {...register('telephonePrincipal', {
                                    required: getMessageErreurChampManquant('Téléphone'),
                                })}
                                error={
                                    formState.errors ? formState.errors.telephonePrincipal : null
                                }
                                placeholder="Ex: 0612345678"
                                warning={numeroNonFrancais('telephonePrincipal')}
                                maskFonction={getTelFormatWithoutSpace}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Téléphone"
                                type="text"
                                maxLength="10"
                                {...register('telephoneSecondaire')}
                                error={
                                    formState.errors ? formState.errors.telephoneSecondaire : null
                                }
                                placeholder="Ex: 0198765432"
                                warning={numeroNonFrancais('telephoneSecondaire')}
                                maskFonction={getTelFormatWithoutSpace}
                            />
                        </Col>
                    </Row>

                    {((motifs && motifs.isNonLicencie) ||
                        (motifs && motifs.isLicencie && isAncienLicencie)) && (
                        <FormulaireCertificatMedical />
                    )}

                    <Row className="margin-top-lg">
                        <Col>
                            <GroupeBouton isHorizontal alignementHorizontal="right">
                                <Bouton
                                    name="etapePrecedente"
                                    label="Retour"
                                    niveau="secondaire"
                                    isLoading={
                                        isLoading ||
                                        isLoadingRenseignerAdressePrincipale ||
                                        isLoadingJustificatifsDomicile ||
                                        isLoadingCertificatMedicalArs
                                    }
                                    onClick={retourEtape}
                                />
                                <Bouton
                                    name="etapeSuivante"
                                    label="Accéder à l'étape suivante"
                                    type="submit"
                                    niveau="primaire"
                                    isLoading={
                                        isLoading ||
                                        isLoadingRenseignerAdressePrincipale ||
                                        isLoadingJustificatifsDomicile ||
                                        isLoadingCertificatMedicalArs
                                    }
                                    disabled={!hasFormValid()}
                                />
                            </GroupeBouton>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </SegmentLoader>
    );
};

CreerCompteAdresse.propTypes = {
    uuidBrouillon: PropTypes.string.isRequired,
    postApi: PropTypes.func.isRequired,
    setEtapeAdresse: PropTypes.func.isRequired,
    isAncienLicencie: PropTypes.bool,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    data: PropTypes.any,
    motifs: PropTypes.object.isRequired,
    retourEtape: PropTypes.func.isRequired,
    isLoadingRenseignerAdressePrincipale: PropTypes.bool.isRequired,
    dataRenseignerAdressePrincipale: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    isLoadingJustificatifsDomicile: PropTypes.bool,
    dataRenseignerJustificatifsDomicile: PropTypes.string.isRequired,
    erreurJustificatifsDomicile: PropTypes.bool,
    isLoadingCertificatMedicalArs: PropTypes.bool,
    dataRenseignerCertificatMedicalArs: PropTypes.string.isRequired,
    erreurCertificatMedicalArs: PropTypes.bool,
    dataAdressePrincipaleRenseignee: PropTypes.shape({
        numeroDeVoie: PropTypes.string,
        typeEtNomDeVoie: PropTypes.string.isRequired,
        extension: PropTypes.string,
        lieuDit: PropTypes.string,
        codePostal: PropTypes.string.isRequired,
        ville: PropTypes.string.isRequired,
        typeJustificatif: PropTypes.string.isRequired,
        justificatifsDomicile: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract))
            .isRequired,
        certificatMedical: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract)),
        itinerant: PropTypes.string,
        immatriculationVehicule: PropTypes.string,
        email: PropTypes.string,
        telephonePrincipal: PropTypes.string,
        telephoneSecondaire: PropTypes.string,
    }),
};
export default connect(
    (state) => {
        const { isLoading, data } = state.adresseVerificationBAN.verifier;
        const {
            isLoading: isLoadingRenseignerAdressePrincipale,
            data: dataRenseignerAdressePrincipale,
        } = state.compte.creer.renseignerAdressePrincipale;
        const {
            data: dataRenseignerJustificatifsDomicile,
            isLoading: isLoadingJustificatifsDomicile,
            erreur: erreurJustificatifsDomicile,
        } = state.compte.creer.renseignerJustificatifsDomicile;
        const {
            data: dataRenseignerCertificatMedicalArs,
            isLoading: isLoadingCertificatMedicalArs,
            erreur: erreurCertificatMedicalArs,
        } = state.compte.creer.renseignerCertificatMedicalArs;
        return {
            isLoading,
            data,
            isLoadingRenseignerAdressePrincipale,
            dataRenseignerAdressePrincipale,
            isLoadingJustificatifsDomicile,
            dataRenseignerJustificatifsDomicile,
            erreurJustificatifsDomicile,
            isLoadingCertificatMedicalArs,
            dataRenseignerCertificatMedicalArs,
            erreurCertificatMedicalArs,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(CreerCompteAdresse);
